<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
<label class="hc-checkbox" [class.hc-checkbox--checked]="checked"
       [class.hc-checkbox--indeterminate]="indeterminate"
       [class.hc-checkbox--disabled]="disabled"
       [class.hc-checkbox--error]="hasError"
       (click)="onLabelClick($event)">
  <!-- Hidden native input — kept for form association only; pointer-events disabled -->
  <input
    type="checkbox"
    class="hc-checkbox__input hc-checkbox__input--hidden"
    [id]="inputId"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    tabindex="-1"
    aria-hidden="true" />

  <span
    class="hc-checkbox__box"
    tabindex="0"
    role="checkbox"
    [attr.aria-checked]="indeterminate ? 'mixed' : checked"
    [attr.aria-disabled]="disabled || null"
    (keydown)="onKeydown($event)">
    @if (checked && !indeterminate) {
      <svg class="hc-checkbox__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.3 4.3L6 11.6L2.7 8.3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    }
    @if (indeterminate) {
      <svg class="hc-checkbox__icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    }
  </span>
  @if (label) {
    <span class="hc-checkbox__label">{{ label }}</span>
  }
  <ng-content></ng-content>
</label>
